import BasePreset from '../base/BasePreset.js'
import fragSrc    from '../../shaders/presets/organic/fragment.glsl'

export default class OrganicPreset extends BasePreset {
    constructor() {
        super()
        this.id   = 'organic'
        this.name = 'Organic'
        this.plan = 'free'
        this.defaultObjectColor = '#22cc66'
        this.defaultBgColor     = '#020f05'
    }

    init(canvas) {
        this._setup(canvas, fragSrc)
        const gl = this.gl
        this.uniforms.uObjectColor = gl.getUniformLocation(this._program, 'uObjectColor')
        this.uniforms.uBgColor     = gl.getUniformLocation(this._program, 'uBgColor')
        this.uniforms.uRotSpeed    = gl.getUniformLocation(this._program, 'uRotSpeed')
        this.uniforms.uRotDir      = gl.getUniformLocation(this._program, 'uRotDir')
        this.uniforms.uMandalIdx   = gl.getUniformLocation(this._program, 'uMandalIdx')
        this.uniforms.uScale       = gl.getUniformLocation(this._program, 'uScale')
    }

    getSchema(plan) {
        if (plan === 'free') return []
        const fields = [
            { key: 'objectColor', type: 'color', label: 'Circle Color', default: this.defaultObjectColor },
            { key: 'bgColor',     type: 'color', label: 'Background',   default: this.defaultBgColor },
        ]
        if (plan === 'pro') {
            fields.push(
                { key: 'rotSpeed', type: 'range',  label: 'Rotation Speed', min: 0, max: 3, step: 0.1, default: 0 },
                {
                    key: 'rotDir', type: 'select', label: 'Direction',
                    options: [{ value: 1, label: 'Left' }, { value: -1, label: 'Right' }],
                    default: 1,
                },
                {
                    key: 'mandalIdx', type: 'select', label: 'Mandala',
                    options: [
                        { value: 0, label: 'Flower of Life' },
                        { value: 1, label: 'Star' },
                        { value: 2, label: 'Nested Rings' },
                        { value: 3, label: 'Spiral' },
                    ],
                    default: 0,
                },
            )
        }
        return fields
    }

    _applyConfigUniforms() {
        const gl = this.gl
        const [or, og, ob] = this._hexToRgb(this._config.objectColor ?? this.defaultObjectColor)
        gl.uniform3f(this.uniforms.uObjectColor, or, og, ob)
        const [br, bg, bb] = this._hexToRgb(this._config.bgColor ?? this.defaultBgColor)
        gl.uniform3f(this.uniforms.uBgColor, br, bg, bb)
        gl.uniform1f(this.uniforms.uRotSpeed,  Number(this._config.rotSpeed  ?? 0))
        gl.uniform1f(this.uniforms.uRotDir,    Number(this._config.rotDir    ?? 1))
        gl.uniform1i(this.uniforms.uMandalIdx, Math.round(Number(this._config.mandalIdx ?? 0)))
        gl.uniform1f(this.uniforms.uScale,     Number(this._config.scale ?? 1.0))
    }
}
